import { connect } from 'react-redux'

import * as OrgSelectors from 'modules/org/selectors'

import ProfilePreview from './component'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
})

export default connect(mapStateToProps)(ProfilePreview)



// WEBPACK FOOTER //
// ./src/layouts/MeetingPreview/index.js